document.addEventListener('DOMContentLoaded', function () {
  if (document.querySelector('body.admin-ospe-ncps')) {
    const manageAllFunctionsEl = document.querySelector('select[ref="manageAllFunctionsSelect"]')
    const managedFunctionCbEls = document.querySelectorAll('[ref="managedFunctionCbs"] input')
    if (manageAllFunctionsEl instanceof HTMLSelectElement) {
      const toggleFunctionCb = function (selectEl: HTMLSelectElement, cbEls: NodeListOf<Element>): void {
        const setDisabled = selectEl.value == '1'
        for (let i = 0; i < cbEls.length; i++) {
          const cb = cbEls[i]
          if (cb instanceof HTMLInputElement) {
            cb.disabled = setDisabled
          }
        }
      }
      manageAllFunctionsEl.addEventListener('change', function() {
        toggleFunctionCb(manageAllFunctionsEl, managedFunctionCbEls)
      })

      toggleFunctionCb(manageAllFunctionsEl, managedFunctionCbEls)
    }manageAllFunctionsEl
  }
})
